import {User} from "firebase/auth";
import {NlaUser} from "@/lib/models.ts";

export const buildUrlWithParams = (endpoint: string, base_url: URL, params: object) => {
  const url = new URL(endpoint, base_url);
  for (const [key, value] of Object.entries(params)) {
    if(value !== undefined){
      url.searchParams.append(key, value);
    }
  }
  return url
}

export const getNlaUsers = async (user: User) => {
  const tokenJson = await user.getIdTokenResult();

  return tokenJson.claims.nlaUsers as NlaUser[] | undefined
}
